import React from 'react';
import { blogPosts } from '../../mockData';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Plus, Edit, Trash2, Eye } from 'lucide-react';

const AdminBlog = () => {
  const handleDelete = (postId) => {
    if (window.confirm('Are you sure you want to delete this post?')) {
      console.log('Delete post:', postId);
    }
  };

  return (
    <div className="p-8">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Blog Management</h1>
          <p className="text-gray-600">Manage blog posts and content</p>
        </div>
        <Button className="bg-[#0A3900] hover:bg-[#1A5C0A]">
          <Plus className="w-4 h-4 mr-2" />
          New Post
        </Button>
      </div>

      <div className="space-y-4">
        {blogPosts.map((post) => (
          <Card key={post.id} className="p-6">
            <div className="flex items-start gap-6">
              <img
                src={post.coverImage}
                alt={post.title}
                className="w-32 h-32 object-cover rounded-lg"
              />
              <div className="flex-1">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">{post.title}</h3>
                    <p className="text-gray-600 mb-3 line-clamp-2">{post.excerpt}</p>
                  </div>
                </div>
                <div className="flex items-center gap-4 mb-3">
                  <span className="text-sm text-gray-600">By {post.author}</span>
                  <span className="text-sm text-gray-600">{post.readTime}</span>
                  <span className="text-sm text-gray-600">{post.publishedAt}</span>
                  <Badge className={post.published ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}>
                    {post.published ? 'Published' : 'Draft'}
                  </Badge>
                </div>
                <div className="flex gap-2">
                  {post.tags.map((tag, idx) => (
                    <Badge key={idx} variant="secondary" className="text-xs">{tag}</Badge>
                  ))}
                </div>
              </div>
              <div className="flex gap-2">
                <Button variant="outline" size="sm">
                  <Eye className="w-4 h-4" />
                </Button>
                <Button variant="outline" size="sm">
                  <Edit className="w-4 h-4" />
                </Button>
                <Button variant="outline" size="sm" onClick={() => handleDelete(post.id)}>
                  <Trash2 className="w-4 h-4 text-red-600" />
                </Button>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default AdminBlog;
